<div #toursList
     id="ng-tours-list"
     class="ng-tours-list">

    <app-incorrect-filters *ngIf="isShowIncorrectFilters"></app-incorrect-filters>

    <ng-container *ngFor="let tour of tours; trackBy: trackByFn; let i = index">
        <app-tour [tour]="tour" [wishlistHotels]="wishlistHotels"></app-tour>

        <app-tour-include *ngIf="i === 0 && isRenderTourIncludesHelp && !isOnlyHotelsSearch"></app-tour-include>
    </ng-container>
    @if (isLoadingMoreTours) {
        <app-tours-skeleton/>
    }
    @if (isToursPaginationEnabled) {
        <app-pagination/>
    } @else {
        <div #loadMoreSentinel class="ng-load-more-sentinel" aria-hidden="true"></div>
    }
</div>
